export default function SelectComponent({ name, icon, options, selected, className, onChange }) {
    const handleChange = (e) => {
        e.preventDefault();
        onChange(e.target.value)
    }
    return (
        <div className={`item-select ${className}`}>
            <div className='icon'>
                {icon}
            </div>
            <select name={name} id={name} onChange={handleChange} defaultValue={selected}>
                {
                    options.map((item, index) => {
                        return(
                            <option  key={`option-${index}`} value={item.id}>
                                {item.name}
                            </option>
                        )
                    })
                }
            </select>
        </div>
    );
};